import React, { useState } from "react";
import { Types } from "./Types";
import styles from "./Components.module.css";
import { useTranslation } from "react-i18next";

const Number = () => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);

  return (
    <div
      className={`form-group draggable ${styles["form-group"]} ${isDragging ? styles["dragging"] : ""}`}
      draggable={true}
      onDragStart={(e) => {
        e.dataTransfer.setData("add", Types.NUMBER);
        setIsDragging(true);
      }}
      onDragEnd={(e) => {
        setIsDragging(false);
      }}
    >
      <span className="fa-stack fa-lg">
        <span className="far fa-square fa-stack-2x"></span>
        <strong className="fa-stack-1x">01</strong>
      </span>
      <br></br>
      <label className="form-control-label">{t("Number")}</label>
    </div>
  );
};

export default Number;
